import React from 'react'

const Sustainable = () => {
  return (
    <div>Sustainable</div>
  )
}

export default Sustainable